<template>
  <div class="breadcrumbs">
    <TText
      style="cursor:pointer;" 
      :value="root_name" 
      @click.native="$emit('clickRoot')"
      :underlined="is_root"
    />
    <div v-for="item in breadcrumbs" :key="`breadcrumbitem${item.id}`" class="breadcrumbs">
      <TIcon name="chevron-right" />
      <TText style="cursor:pointer;" :text="item.name" @click.native="$emit('clickBreadcrumb', item)" />
    </div>
    <div v-if="root_name !== current_folder_name" class="breadcrumbs">
      <TIcon name="chevron-right" />
      <TText :text="current_folder_name" font_weight="400" :underlined="true" />
    </div>
  </div>
</template>
<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';
export default {
  props: ['breadcrumbs', 'root_name', 'is_root', 'current_folder_name'],
  components: {
    TIcon
  },
  data: () => ({
  }),
}
</script>
<style>
.breadcrumbs {
  display: flex;
  align-items: center;
}
</style>
